export default {
  source: 'file',
  events: [],
  eventsLoaded: false,
  rinks: [],
  team: {},
  currentRegistration: {
    'lang': 'en',
    'fname': '',
    'mname': '',
    'lname': '',
    'bdate': '',
    'gender': '',
    'citizen': 'CAN',
    'address': '',
    'address2': '',
    'city': '',
    'state': '',
    'zip': '',
    'country': '',
    'email': '',
    'phone': '',
    'guardians': [
      {
        'fname': '',
        'lname': '',
        'relationship': '',
        'email': '',
        'phone': '',
        'phone2': ''
      },
      {
        'fname': '',
        'lname': '',
        'relationship': '',
        'email': '',
        'phone': '',
        'phone2': ''
      }
    ],
    'lts-checked': 0,
    'email-official-checked': 0,
    'email-offers-checked': 0,
    'email-local-checked': 0,
    'email-official-checked-ca': 0,
    'email-offers-checked-ca': 0,
    'email-local-checked-ca': 0,
    'liability-checked': 0,
    'liability-initials': '',
    'liability-youth-checked': 0,
    'liability-youth-initials': '',
    'admin_notes':''
  },
  transaction: {},
  autoFormFields: {},
  currentTeam: '',
  registrations: []
}